module.exports = __webpack_public_path__ + "img/item10.ed9f0157.png";